if (document.getElementById('hero-video')) {

	document.getElementById('hero-video').onended = function () {
		this.load();
		this.play();
	};

	var video = document.getElementById('hero-video')
	var soundBtn = document.getElementById('sound')

	soundBtn.addEventListener('click', function(e){
		if(video.muted) {
			video.muted = false;
			soundBtn.setAttribute('src', '/wp-content/themes/whiteoctopus/dist/img/sound-on.png')
		} else {
			video.muted = true;
			soundBtn.setAttribute('src', '/wp-content/themes/whiteoctopus/dist/img/sound-off.png')
		}
	})

	var isMobileVideo = false;

	function changeVideoPath(){
		var ww = (window.innerWidth);
		var wh = (window.innerHeight);
		if(ww/wh < 1 && !isMobileVideo){
			video.pause()
			document.querySelector('#hero-video source').setAttribute('src', 'hero-mobile.mp4');
			video.load()
			video.play()
			isMobileVideo = true
		} else if(ww/wh >= 1 && isMobileVideo) {
			video.pause()
			document.querySelector('#hero-video source').setAttribute('src', 'dhero.mp4');
			video.load()
			video.play()
			isMobileVideo = false
		}
		//if(ww < 768)
	}

	window.onresize = changeVideoPath
	changeVideoPath();

}

$(document).ready(function () {

	$('.navbar-toggler').on('click', function () {
		$('.animated-icon').toggleClass('open');
	});


});





